module.exports = __webpack_public_path__ + "img/JAOC_POP_AgedCheese_round.42fec043.png";